export default "__VITE_ASSET__DNwSnzxA__"